// extracted by mini-css-extract-plugin
module.exports = {"UserAvatar":"UserAvatar_UserAvatar__2MQTK"};